import React from 'react'

const ActivitySectionTitle = ({ card }) => {
  const section = card
  return <div>{section.title}</div>
}

export default ActivitySectionTitle
